<template>
  <v-list v-if="sensorGroup && sensorGroup.length > 0" expand>
    <v-list-group
      color="primary"
      v-for="group in sensorGroup"
      :key="group.title"
      :value="group.active"
      @input="handleGroupExpand(group.title, $event)"
      outlined
    >
      <template v-slot:activator>
        <v-list-item-content color="primary">
          <v-list-item-title v-text="group.title"></v-list-item-title>
        </v-list-item-content>
      </template>
      <sensor
        v-for="sensor in group.sensors"
        :key="sensor.uuid"
        :sensor="sensor"
        :selected="selectedSensors.selected.includes(sensor.uuid)"
        :loading="sensor.loading"
        :noData="sensor.noData"
        @click.native="$emit('toggle-sensor', sensor.uuid)"
      ></sensor>
    </v-list-group>
  </v-list>
  <div v-else class="subtitle-1">
    {{ $t("components.pickers.sensorPicker.noSensorsAvailable") }}
  </div>
</template>

<script>
import Sensor from "@/components/miscellaneous/SensorPill.vue";

export default {
  components: {
    Sensor,
  },
  props: ["sensorList", "location", "selectedSensors"],
  data: () => ({
    expandedGroups: {},
  }),
  computed: {
    sensorGroup() {
      if (!this.sensorList || !this.sensorList.sensors) return [];

      const grouppedObj = this.sensorList.sensors.reduce((acc, curr) => {
        const loc = curr.location || "Other";
        if (!acc[loc]) acc[loc] = [];
        acc[loc].push(curr);
        return acc;
      }, {});

      return Object.keys(grouppedObj).map((title) => {
        const sensorsInGroup = grouppedObj[title];
        const hasSelection = sensorsInGroup.some((sensor) =>
          this.selectedSensors.selected.includes(sensor.uuid),
        );

        return {
          title,
          sensors: sensorsInGroup,
          active:
            this.expandedGroups[title] !== undefined
              ? this.expandedGroups[title]
              : hasSelection,
        };
      });
    },
  },
  methods: {
    handleGroupExpand(title, val) {
      this.$set(this.expandedGroups, title, val);
    },
  },
  watch: {
    selectedSensors: {
      handler(newVal) {
        if (!this.sensorList || !this.sensorList.sensors) return;

        const grouppedObj = this.sensorList.sensors.reduce((acc, curr) => {
          const loc = curr.location || "Other";
          if (!acc[loc]) acc[loc] = [];
          acc[loc].push(curr);
          return acc;
        }, {});

        Object.keys(grouppedObj).forEach((title) => {
          const sensorsInGroup = grouppedObj[title];
          const hasSelection = sensorsInGroup.some((sensor) =>
            newVal.selected.includes(sensor.uuid),
          );

          if (hasSelection && this.expandedGroups[title] === undefined) {
            this.$set(this.expandedGroups, title, true);
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
